import React, { FC } from 'react';
import { SimpleModal } from './Modal';
import { StyledButton } from 'components/Buttons/DefaultButton/DefaultButton.styles';
import { CrossButtonBlack } from 'components/Buttons/CrossButton';

interface CorporateRestrictionModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const RESTRICTION_MESSAGE =
    "Corporate has restricted this feature for 123D Locations currently. Please reach out to Corporate if you'd like to discuss this option.";

export const CorporateRestrictionModal: FC<CorporateRestrictionModalProps> = ({ isOpen, onClose }) => (
    <SimpleModal isOpen={isOpen}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.75rem' }}>
            <div style={{ marginRight: '1rem', fontSize: '1.25rem', lineHeight: 1.4, fontWeight: 600 }}>
                Feature Restricted
            </div>
            <CrossButtonBlack
                className="no-fastclick"
                onClick={onClose}
                style={{ position: 'relative', flexShrink: 0 }}
            />
        </div>
        <div style={{ fontSize: '0.95rem', lineHeight: 1.5, marginBottom: '0.75rem', color: 'rgba(0, 0, 0, 0.7)' }}>
            {RESTRICTION_MESSAGE}
        </div>
        <StyledButton
            variant="outlined"
            size="large"
            onClick={onClose}
        >
            OK
        </StyledButton>
    </SimpleModal>
);
